import styled from "styled-components";
import { background_url_dev } from "../../../config";

export const LayoutContainer = styled.div`
	display: flex;
	flex: 1 1 100%;
	flex-direction: column;
	background: url(${background_url_dev});
	z-index: 1;
	background-size: cover;
	padding-bottom: 1%;
	padding-right: 1%;
`;

export const LayoutContainerBase = styled.div`
	display: flex;
	flex: 1 1 100%;
	flex-direction: column;
	background: url(${background_url_dev});
	z-index: 1;
	background-size: cover;
	padding-right: 1%;
`;

export const Body = styled.div`
	overflow-x: hidden;
	overflow-y: auto;
	padding-left: 1%;
	padding-right: 1%;
	padding-bottom: 3%;
	padding-top: 1%;
	height: 100%;
	max-height: 100%;
	background: transparent;
	::-webkit-scrollbar-track {
		background: #4dac27 !important;
	}
	::-webkit-scrollbar-thumb {
		background-color: #006e2d !important;
	}
`;

export const BodyBase = styled.div`
	padding-left: 1%;
	padding-bottom: 3%;
	padding-right: 1%;
	max-height: 100%;
	background: transparent;
	::-webkit-scrollbar-track {
		background: #4dac27 !important;
	}
	::-webkit-scrollbar-thumb {
		background-color: #006e2d !important;
	}
`;
